import { Button, Image } from '@chakra-ui/react';
import ExportIcon from '../../../assets/icons/export-svgrepo-com.svg';
import {
  displayNotification,
  useExportAllMyTasksListMutation,
} from '../../../services';
import { useTypedSelector } from '../../../hooks';
import { useEffect } from 'react';
import {
  isMutationSuccess,
  notifyMutationFailure,
} from '../../../utils/mutation-feedback';

interface IProps {
  filters: any;
}

export const ExportTasks: React.FC<IProps> = props => {
  const [exportTasks, { isLoading: isExportTasksLoading }] =
    useExportAllMyTasksListMutation();

  const exportCurrentFilteredTasks = async () => {
    const response = await exportTasks({
      filters: props.filters,
      export: {
        type: 'xlxs',
        interface: ['brickLynkApp'],
      },
    });

    // The "we're creating your file" toast used to fire even when the export
    // was rejected, leaving the user waiting for a download that never comes
    // (the file arrives asynchronously over Pusher, so nothing else tells
    // them). Only promise the file once the server accepted the job.
    if (!isMutationSuccess(response)) {
      notifyMutationFailure(response, {
        title: 'Could not export your tasks',
        description:
          'No file is being prepared. Please try again in a moment.',
      });
      return;
    }

    displayNotification({
      title: `Please wait, we're creating your file`,
      description: `Don't close this tab or your browser. the file is being prepared and will be downloaded automatically after couple of seconds`,
      status: 'success',
    });
  };

  return (
    <Button
      onClick={exportCurrentFilteredTasks}
      bg="custom_black.1"
      _hover={{ bg: 'custom_black.1' }}
      color="white"
      fontWeight="semibold"
      fontSize="sm"
    >
      <Image src={ExportIcon} alt="plus icon" boxSize="5" mr="1" />
      Export Tasks
    </Button>
  );
};
